import { render, staticRenderFns } from "./ConfirmationForgotPassword.vue?vue&type=template&id=3657bed5&scoped=true"
import script from "./ConfirmationForgotPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmationForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationForgotPassword.vue?vue&type=style&index=0&id=3657bed5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3657bed5",
  null
  
)

export default component.exports